module.exports = __webpack_public_path__ + "img/1571031936.ef775e28.jpg";